<template>
  <div>
    <v-toolbar flat color="white">
      <v-tabs>
          <v-tab @click="setActiveTabName('accounts')">Sessions</v-tab>
          <v-tab @click="setActiveTabName('nas')">NAS</v-tab>
          <v-tab @click="setActiveTabName('check')">Check</v-tab>
          <v-tab @click="setActiveTabName('reply')">Reply</v-tab>

        <!-- <v-tab
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
          >{{ tab.displayName }}</v-tab
        > -->
      </v-tabs>
    </v-toolbar>
    <div  v-if="activeTab =='accounts'" >
        <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-text-field label="Search" v-model="sessionSearch"></v-text-field>
        </v-toolbar>
        <v-data-table
                  :rows-per-page-items="[20]"
                  :items="sessions"
                  :search="sessionSearch"
                  :headers="sessionHeaders"
                  style="cursor: pointer"
                >
                  <template v-slot:items="props">
                      <td class="text-xs-center" >{{props.item.nasipaddress}}</td>
                      <td class="text-xs-center" >{{props.item.framedipaddress}}</td>
                      <td class="text-xs-center" >{{props.item.username}}</td>
                      <td class="text-xs-center" >{{props.item.callingstationid}}</td>
                      <td class="text-xs-center" >{{props.item.acctstarttime}}</td>
                      <td class="text-xs-center" >{{props.item.acctstoptime}}</td>

                  </template>
        </v-data-table>
    </div>
    <div v-if="activeTab =='nas'">
        <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-text-field label="Search" v-model="nasSearch"></v-text-field>
        </v-toolbar>
        <v-data-table
                  :rows-per-page-items="[20]"
                  :items="nas"
                  :search="nasSearch"
                  :headers="nasHeaders"
                  style="cursor: pointer"
                >
                  <template v-slot:items="props">
                      <td class="text-xs-center" >{{props.item.nasname}}</td>
                      <td class="text-xs-center" >{{props.item.shortname}}</td>
                      <td class="text-xs-center" >{{props.item.description}}</td>
                      <td class="text-xs-center" >{{props.item.type}}</td>
                  </template>
        </v-data-table>
    </div>
    <div v-if="activeTab =='check'">
        <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-text-field label="Search" v-model="checkSearch"></v-text-field>
        </v-toolbar>
        <v-data-table
                  :rows-per-page-items="[20]"
                  :items="check"
                  :search="checkSearch"
                  :headers="checkHeaders"
                  style="cursor: pointer"
                >
                  <template v-slot:items="props">
                      <td class="text-xs-center" >{{props.item.username}}</td>
                      <td class="text-xs-center" >{{props.item.attribute}}</td>
                      <td class="text-xs-center" >{{props.item.op}}</td>
                      <td class="text-xs-center" >{{props.item.value}}</td>
                  </template>
        </v-data-table>
    </div>
    <div v-if="activeTab =='reply'">
        <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-text-field label="Search" v-model="replySearch"></v-text-field>
        </v-toolbar>
        <v-data-table
                  :rows-per-page-items="[20]"
                  :items="reply"
                  :search="replySearch"
                  :headers="replyHeaders"
                  style="cursor: pointer"
                >
                  <template v-slot:items="props">
                      <td class="text-xs-center" >{{props.item.username}}</td>
                      <td class="text-xs-center" >{{props.item.attribute}}</td>
                      <td class="text-xs-center" >{{props.item.op}}</td>
                      <td class="text-xs-center" >{{props.item.value}}</td>
                  </template>
        </v-data-table>
    </div>
  </div>
</template>
<script>
import Api from "../services/Api";
export default {
  data() {
    return {
      activeTab: "accounts",
      check: [],
      nas: [],
      reply: [],
      sessions: [],
      checkSearch: '',
      replySearch: '',
      nasSearch: '',
      sessionSearch: '',
      nasHeaders: [
        {
          text: "IP Address",
          align: "center",
          value: 'nasname'
        },
        {
          text: "Name",
          align: "center",
          value: 'shortname'
        },
        {
          text: "Description",
          align: "center",
          value: 'description'
        }
        ,
        {
          text: "Type",
          align: "center",
          value: 'type'
        }],
        checkHeaders: [
        {
          text: "Username",
          align: "center",
          value: 'username'
        },
        {
          text: "Attribute",
          align: "center",
          value: 'attribute'
        },
        {
          text: "Operator",
          align: "center",
          value: 'op'
        },
        {
          text: "Value",
          align: "center",
          value: 'value'
        }
        ],
        replyHeaders: [
        {
          text: "Username",
          align: "center",
          value: 'username'
        },
        {
          text: "Attribute",
          align: "center",
          value: 'attribute'
        },
        {
          text: "Operator",
          align: "center",
          value: 'op'
        },
        {
          text: "Value",
          align: "center",
          value: 'value'
        }
        ],
      sessionHeaders: [
        {
          text: "NAS IP Address",
          align: "center",
          value: 'nasipaddress'
        },
        {
          text: "Framed IP Address",
          align: "center",
          value: 'framedipaddress'
        },
        {
          text: "Username",
          align: "center",
          value: 'username'
        }
        ,
        {
          text: "MAC Address",
          align: "center",
          value: 'callingstationid'
        },
        {
          text: "Session Start",
          align: "center",
          value: 'acctstarttime'
        },
        {
          text: "Session End",
          align: "center",
          value: 'acctstoptime'
        }
        ],
      tabs: [
        {
          name: "accounts",
          displayName: "Sessions",
        },
        { name: "nas", displayName: "NAS" },
        {
          name: "check",
          displayName: "Check",
        },
        { name: "reply", displayName: "Reply" },
      ],
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.fetchRadiusAccounts();
      this.fetchNas();
      this.fetchRadiusReply();
      this.fetchRadiusCheck();
    },
    async fetchRadiusAccounts() {
      await Api()
        .get("/radius/sessions/all/active")
        .then((res) => {
          this.sessions = res.data;
        });
    },
    async fetchRadiusReply() {
        await Api()
        .get("/radius/reply")
        .then((res) => {
          this.reply = res.data;
        });
    },
    async fetchRadiusCheck() {
        await Api()
        .get("/radius/check")
        .then((res) => {
          this.check = res.data;
        });
    },
    async fetchNas() {
      await Api()
        .get("/radius/nas")
        .then((res) => {
          this.nas = res.data;
        });
    },
    setActiveTabName(tab) {
      this.activeTab = tab;
    },
    displayContents(tab) {
      return (this.activeTab = tab);
    },
  },
};
</script>